import { useLocalization } from '@/shared/composables/localization'

export const getServiceLabel = (key: string, number?: string) => {
  const { t } = useLocalization()

  const servicesLabels: { [key in string]: string } = {
    'other': t('general.otherDescription', { number }),
    'AccessGroupManagement': t('general.AccessGroupManagementDescription', { number }),
    'Alarm': t('general.AlarmDescription', { number }),
    'APIAccess': t('general.APIAccessDescription', { number }),
    'AudiofilesManagement': t('general.AudiofilesManagementDescription', { number }),
    'AutoDial': t('general.AutoDialDescription', { number }),
    'BlackWhiteList': t('general.BlackWhiteListDescription', { number }),
    'Blf': t('general.BlfDescription', { number }),
    'CallIntrusion': t('general.CallIntrusionDescription', { number }),
    'CallWaiting': t('general.CallWaitingDescription', { number }),
    'CDRsAccess': t('general.CDRsAccessDescription', { number }),
    'CLIP': t('general.CLIPDescription', { number }),
    'CLIR': t('general.CLIRDescription', { number }),
    'Conference': t('general.ConferenceDescription', { number }),
    'DialLocalNumbers': t('general.DialLocalNumbersDescription', { number }),
    'DoNotDisturb': t('general.DoNotDisturbDescription', { number }),
    'FMC': t('general.FMCDescription', { number }),
    'FollowMe': t('general.FollowMeDescription', { number }),
    'Forward': t('general.ForwardDescription', { number }),
    'Hold': t('general.HoldDescription', { number }),
    'InstantMessaging': t('general.InstantMessagingDescription', { number }),
    'IVR': t('general.IVRDescription', { number }),
    'MissedCallNotification': t('general.MissedCallNotificationDescription', { number }),
    'MptyConference': t('general.MptyConferenceDescription', { number }),
    'MultiTerminal': t('general.MultiTerminalDescription', { number }),
    'PersonalWebCabinetAccess': t('general.PersonalWebCabinetAccessDescription', { number }),
    'QueryAlarm': t('general.QueryAlarmDescription', { number }),
    'QueryFwd': t('general.QueryFwdDescription', { number }),
    'QueryServiceList': t('general.QueryServiceListDescription', { number }),
    'QuerySpeedDial': t('general.QuerySpeedDialDescription', { number }),
    'Redial': t('general.RedialDescription', { number }),
    'RTUClient': t('general.RTUClientDescription', { number }),
    'SavePrompt': t('general.SavePromptDescription', { number }),
    'SetAlarm': t('general.SetAlarmDescription', { number }),
    'SetDND': t('general.SetDNDDescription', { number }),
    'SetFwd': t('general.SetFwdDescription', { number }),
    'SetSpeedDial': t('general.SetSpeedDialDescription', { number }),
    'SpeedDial': t('general.SpeedDialDescription', { number }),
    'SubscriberAutoDialCallBack': t('general.SubscriberAutoDialCallBackDescription', { number }),
    'SubscriberPickUp': t('general.SubscriberPickUpDescription', { number }),
    'Transfer': t('general.TransferDescription', { number }),
    'VoiceMailBoxAccess': t('general.VoiceMailBoxAccessDescription', { number }),
    'VoiceMailForwarding': t('general.VoiceMailForwardingDescription', { number }),
    'VoiceMailLeaveMessage': t('general.VoiceMailLeaveMessageDescription', { number }),
    'WebCallbackOrder': t('general.WebCallbackOrderDescription', { number }),
    'WebToFaxD': t('general.WebToFaxDescription', { number }),
  }

  return servicesLabels[key]
}
